import { ApiInterface, EmptyObject } from '@stetamalo/cloud-platform/catalog/api';
import { Schemy } from 'schemy-ts';
import { ApiConfig } from 'services/support/utils/types/api-config';
import { Discount } from '../../entities/discounts';
export type Interface = ApiInterface<{
  response: Discount;
  pathParams: { discountId: string };
  body: Partial<Omit<Discount, 'createdAt' | 'updatedAt' | 'id'>>;
  claims: { tenantId: string; 'cognito:username': string };
  queryParams: EmptyObject;
}>;

export const config: ApiConfig<Interface> = {
  name: 'api-update-discounts',
  method: 'PUT',
  basePath: 'discounts',
  path: '/{discountId}',
  tablePermission: 'readWrite',
  scope: 'SUPER_ADMIN',
  schema: Schemy.schema<Interface['body']>({
    name: { type: String },
    amount: { type: Number, min: 0 },
    percentage: { type: Number, min: 0 },
    products: { type: [String] },
    type: {
      type: String,
      required: false,
      enum: ['PERCENTAGE', 'AMOUNT', 'PERCENTAGE_AMOUNT', 'AMOUNT_PERCENTAGE'],
      min: 1,
    },
    dateInitial: { type: Number, required: false },
    dateEnd: { type: Number, required: false },
  }),
};
